import { NewDynamicTab } from "../../../components/Page";
import { JvvnlGeneration as JvvnlGenerationDates } from "../../../config/DefaultDates";
import { JvvnlTitle } from "../Jvnnl_Dashboard";
import ForecastPrediction from "./ForecastPrediction";

export function JvvnlForecast() {
  return (
    <NewDynamicTab
      defaultDates={JvvnlGenerationDates}
      header="Forecast Prediction"
      middleComponent={<JvvnlTitle />}
      showTabs={false}
      tabs={{ "Forecast Prediction": <ForecastPrediction /> }}
      showDates={false}
      showReactSelect={false}
    />
  );
}
